const translations = {
    cancel: 'Cancel',
    expirationDate: 'Expiration Date',
    expirationDateBeforeIssuedDate: 'Expiration date cannot be before the issue date.',
    issuedDate: 'Issued Date',
    issuedDateInFuture: 'Issue date cannot be in the future.',
    licenseNumber: 'Pesticide License Number',
    maxLengthExceeded: 'Maximum character limit exceeded.',
    saving: 'Saving…',
    state: 'State',
    statePlaceholder: 'Select a state'
};

export default translations;
